module.exports = __webpack_public_path__ + "img/25_36.12a6bcc7.png";